import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

const style = {
  height:10,
  minHeight:0,
  overflow:'hidden',
}


export default function ReorderButtons({
  onEvent,
  channelIndex,
  channels
}){
  return (
    <td class="rel">
      <div class="show-on-row-hover">
        <div>
          <DeleteChannelButton/>
          {false && <MoveUp {...{channelIndex,onEvent}}/>}
        </div>
        {false && <MoveDown {...{channelIndex,channels,onEvent}}/>}
      </div>
    </td>
  )
}


function MoveUp({channelIndex,onEvent}){

  return (<div style={style} class="hoverable" 
            onClick={(e) => {
              e.stopPropagation();

              if( channelIndex === 0 ){
                return;
              }

              onEvent({
                type:"nodeOrderChange",
                toMoveIndex:channelIndex,
                direction:"up"
              })

            }}>
            <ArrowDropUpIcon style={{transform:'translateY(-8px)'}}/>
          </div>
  )
}

function DeleteChannelButton({channelIndex,onEvent}){
  return (

    <div onClick={(e) => {
      e.stopPropagation();
      ;

    }} class="hoverable" style={{position:'absolute', top:0,
      left:'50%',
      transform:'translateX(-200%)',
      width:10,height:10}}>x</div>
  )

}

function MoveDown({channelIndex,channels,onEvent}){
  return (

      <div>
          <div style={style} class="rel hoverable" onClick={(e) => {
            e.stopPropagation();
            if(channelIndex === (channels.length-1)){
              return; 
            }
            onEvent({
              type:"nodeOrderChange",
              toMoveIndex:channelIndex,
              direction:"down"
            })

          }}>
            <ArrowDropDownIcon style={{position:'absolute',bottom:-6}}/>
          </div>
        </div>
  )
}


